import { Observable } from 'rxjs';
import { Alert } from 'src/app/models/alert';
import type { AlertDetailDialogData } from './alert-detail-dialog.component';

export type AlertDialogResult =
  | { action: 'viewCase'; alert: Alert }
  | { action: 'viewIssue'; issueId: string; assetId: string };

// IssueDetailComponent both lives inside the triage dialog and opens it, so it cannot import the dialog; app.module binds this to AlertTriageDialogService.
export abstract class AlertTriageOpener {
  // The alert the URL names, re-read on every navigation.
  abstract readonly linkedAlertId$: Observable<string>;
  // AlertDialogV2 on opens the Triage Dialog; off, missing or not yet loaded opens the Quick View. Emits the close result.
  abstract open(data: AlertDetailDialogData): Observable<AlertDialogResult | undefined>;
  // Steps an open Triage Dialog, else opens.
  abstract show(data: AlertDetailDialogData): void;
  // The URL's alert: from the host's list when it has it, else GET alert/{id} without siblings; a miss drops the param.
  abstract openLinked<T>(find: (id: string) => T | undefined, fromAlert: (alert: Alert) => T, open: (seed: T) => void): void;
}
